import React from 'react';
import { useParams } from 'react-router-dom';
import { Skeleton } from '../../../../../components/ui/skeleton';
import { TableCell, TableRow } from '../../../../../components/ui/table';

function FileListItemSkeleton() {
  const { folderId } = useParams<{ folderId: string }>();
  const isInRecentsView = folderId === 'recents';

  return (
    <TableRow data-testid="file-list-skeleton" className="hover:bg-transparent">
      {/* Name Column */}
      <TableCell className="h-14 w-[45%] min-w-[250px] pl-4">
        <div className="flex items-center gap-3">
          <Skeleton className="h-8 w-8 rounded flex-shrink-0" />
          <Skeleton className="h-3.5 flex-1 min-w-0" />
        </div>
      </TableCell>

      {/* Duration Column */}
      <TableCell className="w-[70px] text-center">
        <Skeleton className="h-3 w-12 mx-auto" />
      </TableCell>

      {/* Folder Column (Recents view only) */}
      {isInRecentsView && (
        <TableCell className="hidden sm:table-cell w-[100px] text-center">
          <Skeleton className="h-3 w-16 mx-auto" />
        </TableCell>
      )}

      {/* Creator Column */}
      <TableCell className="hidden md:table-cell w-[80px] text-center">
        <Skeleton className="h-3 w-14 mx-auto" />
      </TableCell>

      {/* Date Column */}
      <TableCell className="w-[60px] text-center">
        <Skeleton className="h-3 w-16 mx-auto" />
      </TableCell>

      {/* Action Menu Column */}
      <TableCell className="w-[44px]">
        <div className="flex justify-end">
          <Skeleton className="h-6 w-6 rounded-full opacity-0" />
        </div>
      </TableCell>
    </TableRow>
  );
}

export default FileListItemSkeleton;
